export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5676.7a963c5b.jpg";